function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilledCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.001,
    height: 22.999,
    viewBox: "0 0 25.001 22.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3566.39 5322.288a2.72 2.72 0 1 1 2.719 2.611 2.673 2.673 0 0 1-2.719-2.611zm-10.87 0a2.72 2.72 0 1 1 2.721 2.611 2.67 2.67 0 0 1-2.721-2.611zm3.221-3.654a3.786 3.786 0 0 1-3.73-2.944l-2.65-12.741h-2.816a.525.525 0 1 1 0-1.049h3.259a.536.536 0 0 1 .531.418l.565 2.718h19.555a.533.533 0 0 1 .545.524.279.279 0 0 1-.005.067l-.85 6.532a2.685 2.685 0 0 1-2.7 2.289h-14.585l.215 1.035a2.7 2.7 0 0 0 2.666 2.1h12.544a.525.525 0 1 1 0 1.049z",
    transform: "translate(-3549 -5301.9)",
    style: {
      fill: "#33a0fc"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledCart);
export default __webpack_public_path__ + "static/media/filled_cart.e1078ace.svg";
export { ForwardRef as ReactComponent };